import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";

import Sortable from "../../../../componets/Sortable";
import { reorderCategories } from "../../../../actions/sticker_maker/categoriesActions";

const Reorder = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.stickerMaker.categories.reorderIds);
  const categories = useAppSelector(state => state.stickerMaker.categories.entities);

  function onClickSave(ids: any[]) {
    dispatch(reorderCategories({ ids }));
  }

  return (
    <div className='v-categories-reorder'>
      <h6 className="v-content-label o-sm">Reorder</h6>

      {
        reorderIds &&
          <Sortable
              ids={reorderIds}
              onClickSave={onClickSave}
              items={categories}
              titleKey='name'
              imageKey='image_url'
          />
      }
    </div>
  )
}

export default Reorder;
